export default __webpack_public_path__ + "95d8cddaec6cc97c22e71becef440f3d.jpg";